import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

export class SelectUrl extends Component {
  static displayName = SelectUrl.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      local_net_id: '',
      local_unit_id: '',
      current_user_type: localStorage.getItem('login_user_type'),
      selectedUrl: props.selectedUrl, // 將selectedUrl設置為狀態
      parentName: props.parentName,
      version: props.version
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { parentName } = nextProps;
    if (parentName === 'Statistical' && nextProps.formData.statistical_unit_name !== prevState.local_net_id) {
      return {
        local_net_id: nextProps.formData.statistical_net_name,
        local_unit_id: nextProps.formData.statistical_unit_name,
      };
    }
    return null;
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedUnit !== prevProps.selectedUnit || this.props.local_unit_name !== prevProps.local_unit_name || prevProps.version !== this.props.version) {
      this.loadData();
    }
  }

  loadData() {
    this.setState({ options: [] });
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;
    const formData = new FormData();
    if (parentName === 'Excel') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    } else if (parentName === 'Statistical') {
      formData.append("current_user_type", localStorage.current_user_type);
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", this.props.local_unit_name);

    } else if (parentName === 'url') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
      formData.append("local_unit_name", this.props.local_unit_name);
      formData.append("version", this.props.version);
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        //console.log("Received data:", data);
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options: rows });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;
    const httpIndex = selectedText.indexOf('http');
    const url_addr = httpIndex >= 0 ? selectedText.substring(httpIndex) : '';
    this.setState({
      selectedName: url_addr
    }, () => {
      // console.log("已更新的selectedName狀態：", this.state.selectedName);
    });

    this.props.onChange({ target: { name, value, selectedName: url_addr } });
  };




  render() {

    return (
      <Input
        id={this.state.id}
        name={this.state.name}
        onChange={this.handleSelectChange}
        type='select'
        value={this.props.selectedUrl} // 使用 prop 設置選擇的值
      >
        <option key="0" value="">
          請選擇
        </option>
        {this.state.options.map(option => (
          <option key={option.id} value={option.id}>
            {option.url_name}-{option.url_addr}
          </option>
        ))}
      </Input>
    );
  }
}